import user from './reducers/user'
import ready from './reducers/ready'

export const reducerList = {
  user,
  ready
}

export default reducerList
